import { render } from "./ErrorsLog.vue?vue&type=template&id=5c410606&scoped=true&ts=true"
import script from "./ErrorsLog.vue?vue&type=script&lang=ts"
export * from "./ErrorsLog.vue?vue&type=script&lang=ts"

import "./ErrorsLog.vue?vue&type=style&index=0&id=5c410606&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c410606"]])

export default __exports__